export const profileFields = [
	'email',
	'firstName',
	'lastName',
	'location',
] as const;
